const isPasswordValid = (password) => {
	return password && password.length >= 8;
};

export default isPasswordValid;